import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const MovementTypeList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                // Row is a MovementTypeEquipmentStatus record — open the MT using MovementTypeId
                sessionStorage.setItem('editingMovementType', JSON.stringify({ Id: row.MovementTypeId }))
                sessionStorage.setItem('operationType', operation)
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'MovementTypeEquipmentStatus'}
            api='secondary'
            showTitle={true}
            title={'Movement Types'}
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/movementTypeCrud', 'Create', t('Add') + ' ' + t('Movement') + ' ' + t('Type'), row)],
                ['Edit', (row) => newRoute('containerControl/movementTypeCrud', 'Edit', t('Edit') + ' ' + t('Movement') + ' ' + t('Type'), row)],
                ['Copy', (row) => newRoute('containerControl/movementTypeCrud', 'Copy', t('Copy') + ' ' + t('Movement') + ' ' + t('Type'), row)],
            ])}
        />
    )
}